import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import Link from '@ep/components/Link';
import { SecondaryText } from '@ep/components/Typography';
import theme from '@ep/theme';
import React, { Fragment } from 'react';
import Arrow from './arrow.svg';

export interface BreadcrumbProps {
  pathname: string;
}

const PositionDiv = styled.div`
  position: relative;
  z-index: ${theme.zIndex.breadcrumb};

  ${theme.mediaQueries.mobileAndTablet} {
    display: none;
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${theme.colors.white};
  padding: 0.5rem 0;
  text-transform: capitalize;
`;

const StyledContainer = styled(Container)`
  display: flex;
  height: 3.125rem;
  align-items: center;
`;

const AncestorLink = styled(Link)`
  color: ${theme.colors.duskBlue};
  font-size: ${theme.typography.toRem(20)};
  font-weight: bold;
`;

const StyledArrow = styled(Arrow)`
  margin: 0 1rem;
`;

const CurrentPage = styled(SecondaryText)`
  color: ${theme.colors.darkGray};
  font-size: ${theme.typography.toRem(20)};
  font-weight: bold;
`;

const pathBlacklist = ['company', 'customers'];

function Breadcrumb({ pathname }: BreadcrumbProps) {
  const ancestors = pathname.split('/').filter(path => path !== '');

  const ancestorsDisplay = ancestors
    .map(path => decodeURIComponent(path).replace(/-/g, ' '))
    .map(path => path.replace(/\bcastingportal\b/g, 'Casting Portal'))
    .map(path => path.replace(/\bdirect deposit canada\b/g, 'Direct Deposit Canada'))
    .map(path => path.replace(/\bdirect deposit\b/g, 'Direct Deposit US'))
    .map(path => path.replace(/\bproductionportal\b/g, 'Production Portal'))
    .map(path => path.replace(/\bproductionlot\b/g, 'Production Lot'))
    .map(path => path.replace(/\bvista5\b/g, 'Vista 5'))
    .map(path => path.replace(/\bus\b/g, 'US'))
    .map(path => path.replace(/\buk\b/g, 'UK'))
    .map(path => path.replace(/\bsmartpo\b/g, 'SmartPO'))
    .map(path => path.replace(/\bsmarttime\b/g, 'SmartTime'))
    .map(path => path.replace(/\bsmartstart\b/g, 'SmartStart'))
    .map(path => path.replace(/\bsmartaccounting\b/g, 'SmartAccounting'))
    .map(path => path.replace(/\bworkers\b/g, `Workers'`))
    .map(path => path.replace(/\bw 2\b/g, 'W-2'))
    .map(path => path.replace(/\bSb\b/g, 'SB'))
    .map(path => path.replace(/\bep\b/g, 'EP'))
    .map(path => path.replace(/\bmyep\b/g, 'my EP'))
    .map(path => path.replace(/\bsmarthub\b/g, 'SmartHub'))
    .map(path => path.replace(/\band\b/g, '&'))
    .map(path => path.replace(/\bepol\b/g, 'EPOL'));

  // if (ancestors.filter(path => !pathBlacklist.includes(path)).length < 2) {
  //   return null;
  // }

  const [currentPage] = ancestorsDisplay.splice(ancestorsDisplay.length - 1, 1);

  return (
    <PositionDiv>
      <Background>
        <StyledContainer>
          {/* <AncestorLink to="/">Home</AncestorLink>
          <StyledArrow /> */}
          {ancestorsDisplay.map((ancestor, index) => {
            if (pathBlacklist.includes(ancestor)) {
              return null;
            }

            const to = `/${ancestors.slice(0, index + 1).join('/')}`;
            return (
              <Fragment key={to}>
                <AncestorLink to={to}>{ancestor}</AncestorLink>
                <StyledArrow />
              </Fragment>
            );
          })}
          <CurrentPage>{currentPage}</CurrentPage>
        </StyledContainer>
      </Background>
    </PositionDiv>
  );
}

export default React.memo(Breadcrumb);
